import { queryOptions } from "@tanstack/react-query";
import { QUERY_KEYS, SHORT_STALE_TIME } from "@/common/api/config";
import { fetchUserProfile } from "@/entities/profile/api/requests";

export const getProfileQueryOptions = (token: string) =>
  queryOptions({
    queryKey: [QUERY_KEYS.USER_PROFILE, token],
    queryFn: () => fetchUserProfile(token),
    enabled: !!token,
    staleTime: SHORT_STALE_TIME,
    refetchOnWindowFocus: false,
  });
